import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["addOption", "option", "optionsNote"];
  static values = { savedOptions: Array };

  connect() {
    const checked = this.element.querySelector("[name$='[kind]']:checked");
    if (checked) this.element.dataset.kind = checked.value;
  }

  toggle(event) {
    this.element.dataset.kind = event.target.value;
    this.checkOptions();
    if (this.#takesOptions && !this.hasOptionTarget)
      this.addOptionTarget.click();
  }

  checkOptions() {
    const filled = this.optionTargets.filter((option) => option.value.trim());
    this.optionTargets.forEach((option) => {
      option.required = this.#takesOptions && !filled.length;
      option.setCustomValidity("");
    });
    if (this.#takesOptions && this.#changed(filled)) this.#flagProblems(filled);

    const problem = this.#firstProblem;
    this.optionsNoteTarget.textContent = problem?.validationMessage ?? "";
    if (!problem) delete this.element.dataset.optionsReported;
  }

  report(event) {
    if (!event.target.validity.customError) return;

    event.preventDefault();
    if (event.target === this.#firstProblem) event.target.focus();
    this.element.dataset.optionsReported = "";
  }

  reportRepeats(event) {
    if (
      !event.target.validity.customError ||
      !this.#repeats.includes(event.target)
    )
      return;

    event.stopImmediatePropagation();
    this.element.dataset.optionsReported = "";
  }

  optionTargetConnected() {
    this.checkOptions();
  }

  optionTargetDisconnected() {
    if (!this.element.isConnected) return;

    if (this.#takesOptions && !this.hasOptionTarget)
      this.addOptionTarget.click();
    this.checkOptions();
  }

  #changed(filled) {
    return (
      JSON.stringify(filled.map((option) => option.value.trim())) !==
      JSON.stringify(this.savedOptionsValue)
    );
  }

  #flagProblems(filled) {
    const repeats = this.#repeats;
    repeats.forEach((option) =>
      option.setCustomValidity("You can't have duplicate options."),
    );
    if (!repeats.length && filled.length === 1)
      filled[0].setCustomValidity("Add at least two options.");
  }

  get #firstProblem() {
    return this.optionTargets.find((option) => option.validity.customError);
  }

  get #repeats() {
    const key = (option) => option.value.trim().toLowerCase();
    const filled = this.optionTargets.filter(key);
    return filled.filter(
      (option) =>
        filled.filter((other) => key(other) === key(option)).length > 1,
    );
  }

  get #takesOptions() {
    return ["select", "multi_select"].includes(this.element.dataset.kind);
  }
}
